import { useState, useEffect } from "react";
import { message } from "antd";
import API from "../../../../services/API";

export default function useFurnishingChanges({ userId }) {
    const [furnishingChanges, setFurnishingChanges] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getFurnishingChanges();
    }, [userId]);

    const getFurnishingChanges = async () => {
        if (!userId) return;
        try {
            setLoading(true);
            const res = await API.getFurnishingChanges({ userId });
            setFurnishingChanges(res || []);
        } catch (error) {
            message.error('Failed to load furnishing changes.');
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    return {
        furnishingChanges,
        loading,
        getFurnishingChanges
    };
}
